const initialState: string = '';

const waBillingReportFileReducer = (state: string = initialState, action: any) => {
    switch (action.type) {
        case 'PUT_FILE': {
            return action.file;
        }
        case 'CLEAR_FILE': {
            return '';
        }
        default:
            return state;
    }
}

export default waBillingReportFileReducer;
